import Swal from "sweetalert2";
import { EnefApiService } from "../services/EnefApiService";

const api = new EnefApiService();

export const addFavoritesTraining = async (payload) => {
  const res = await api.makeHttpRequest({
    method: 'POST',
    url: '/site/add-treinamento',
    data: payload
  });
  if(!res){
    window.location.href = '/treinamentos'
  }

  return res;
}

export const addFavoritesModules = async ( payload ) => {
  const res = await api.makeHttpRequest({
    method: 'POST',
    url: '/site/add-categoria',
    data: payload
  });
  
  if(!res){
    window.location.href = '/carreiras'
  }

  return res;
}

export const buyProduct = async ( payload ) => {   
    const data = {
      type: payload.Tipo || null,
      redirectId: payload.Id || null
    }
    
    saveBuyProduct(data);
    window.location.href = '/checkout'
}

export const saveBuyProduct = ( payload ) => {
  localStorage.setItem('buy', JSON.stringify(payload))
}
